module.exports = __webpack_public_path__ + "images/calling.fed6e17b.png";